export default {
    getModuloPlural: { method: 'get', url: 'URL' },
    postModuloPlural: { method: 'post', url: 'URL' },
    putModuloPlural: { method: 'put', url: 'URL/{id}' },
    deleteModuloPlural: { method: 'delete', url: 'URL/{id}' },
}
